import {kSystemImages} from "../../constants/images";

export default function SystemSearchEmptyResultImage() {
    // Used through the app to display image when search
    // provides empty results

    // BUILD
    return (
        <div className={"flex h-[200px] min-h-[200px] items-center justify-center space-y-[16px]"}>
            <img className={"object-contain w-full h-full"}
                 src={kSystemImages.emptyResultFox} />
        </div>
    );
}